/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'

import {Box, Container, Stack, Heading} from '@salesforce/retail-react-app/app/components/shared/ui'

import LinksList from '../links-list'
import {categoryUrlBuilder} from '../../utils/url'
import ContentAsset from '../../pages/content-detail/content-asset'
import {mainMenuItemSelected} from '../../integrations/segment/app/page/home'
import {SegmentContext} from '../../integrations/segment/app/contexts'

const MobileListMenuContent = ({item, itemsKey, onClose, initialFocusRef}) => {
    const {locale} = useIntl()
    const segmentContext = useContext(SegmentContext)
    const items = item?.[itemsKey] || []

    return (
        <Container as={Stack}>
            <Box>
                <Box className="container-flex">
                    <Box className="level-2-menu-block">
                        <Box className="level-2-heading">
                            <Heading as="h3" className="level-2-heading-text">
                                {item?.name}
                            </Heading>
                        </Box>
                        <Box className="level-2-link-block">
                            {items?.map((item, index) => {
                                const {id, name} = item
                                const items = item[itemsKey]

                                const heading = {
                                    href: categoryUrlBuilder(item, locale),
                                    text: name,
                                    styles: {
                                        fontSize: 'md',
                                        marginBottom: 2
                                    }
                                }

                                const links = items

                                return (
                                    <LinksList
                                        key={id}
                                        heading={heading}
                                        links={links}
                                        color={'gray.900'}
                                        onLinkClick={() => {
                                            onClose
                                            mainMenuItemSelected(item, segmentContext)
                                        }}
                                        {...(index === 0 ? {headingLinkRef: initialFocusRef} : {})}
                                    />
                                )
                            })}
                        </Box>
                    </Box>
                    <Box className="menu-category-images">
                        {item?.c_headerMenuItemAssets_pwa?.map((item, index) => {
                            const assetId = item
                            return <ContentAsset key={index} id={assetId} />
                        })}
                    </Box>
                </Box>
            </Box>
        </Container>
    )
}

MobileListMenuContent.propTypes = {
    item: PropTypes.object,
    itemsKey: PropTypes.string,
    maxColumns: PropTypes.number,
    onClose: PropTypes.func,
    initialFocusRef: PropTypes.object
}

export {MobileListMenuContent}
